import Lng from "../3x1010/Lng.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";

export default class PageCommon {
    constructor() {
    }
    init($data) {
        $(".js-logout").on("click", this.doLogout.bind(this));
    
        // dispaccio un evento globale
        try {
            this.dispatchInitEvent(TheDisp.EV_PAGECOMMON_INITED);
        } catch (error) {
            console.log(error);
        }
      
    }
  

    dispatchInitEvent(evenTyepe) {
        // dispaccio un evento globale
        let ev = new Event(evenTyepe);
        ev.payload = { page: this }
        TheDisp.dispatchEvent(ev);
    }

    get isHomepage() {
        return false;

    }

  
    doLogout() {
        AuthWiz.doLogout("/");
    }

    showPreloader(flag, percent = null) {
        if (flag) {
            if (percent == null) {
                $(".js-percent", $(".js-preloader")).hide();
            } else {
                $(".js-percent", $(".js-preloader")).show();
                $(".js-percent", $(".js-preloader")).text(percent);
            }
            jQuery(".js-preloader").show();
        } else {
            jQuery(".js-preloader").hide();
        }
    }

    static showPreloader(flag, percent = null) {
        if (flag) {
            if (percent == null) {
                $(".js-percent", $(".js-preloader")).hide();
            } else {
                $(".js-percent", $(".js-preloader")).show();
                $(".js-percent", $(".js-preloader")).text(percent);
            }
            jQuery(".js-preloader").show();
        } else {
            jQuery(".js-preloader").hide();
        }
    }

    static disable(mc, lFlag, opacity = 0.5) {
        if (lFlag) {
            mc.css("pointer-events", "none");
            mc.css("opacity", opacity);
        } else {
            mc.css("pointer-events", "all");
            mc.css("opacity", 1);
        }
    }

   
}



